import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button, Text } from '@fragments';
import { IconArrowRight } from '@tabler/icons-react';
import PlanCard from '../../../../../../components/PlanCard';
import PlanScene from '../../../../../../components/PlanScene';
import { PLAN_ART_OUTPUTS, PUBLIC_PLANS, planRows } from '../../../../../../enums/plans';
import { formatCredits, formatMoney } from '../../../../../../data/payments';
import './styles.scss';

// The plans as the plan dialog compares them (its pitch with the plan scene, the
// cards side by side, the top plan featured), read from the public catalog. A visitor
// has no account to pay with yet: a card's button keeps the plan for after the
// profile is ready and leads to the @.
export default function Plans({ t, locale, reveal, root, choose }) {
  const host = useRef(null);
  const seen = useInView(host, { root, once: true, amount: 0.2 });
  const { currency, plans } = PUBLIC_PLANS;
  const count = units => formatCredits(units, locale);
  const top = plans[plans.length - 1];
  const outputs = PLAN_ART_OUTPUTS[top.plan].map(([id, icon]) => ({ id, icon, label: t(`planArt_${top.plan}_${id}`) }));
  return <motion.section className="studio-landing__section studio-landing-plans" aria-labelledby="studio-landing-plans" {...reveal}>
    <span className="studio-landing-plans__ambient" aria-hidden="true" />
    <div className="studio-landing-plans__layout">
      <div className="studio-landing-plans__intro">
        <Text.subheading contrast={6}>{t('planChooseEyebrow')}</Text.subheading>
        <Text.h2 id="studio-landing-plans" contrast={9} weight={400}>{t('landingPlansTitle')}</Text.h2>
        <Text.p contrast={7}>{t('landingPlansText')}</Text.p>
        <div ref={host} className="studio-landing-plans__scene" role="img" aria-label={t('planArt_alt', { plan: t(`planName_${top.plan}`) })}>
          {seen && <PlanScene units={top.monthly_credits} locale={locale} outputs={outputs} unitsLabel={t('planArtMonthly')} />}
        </div>
      </div>
      <div className={`studio-plan-compare is-${plans.length}`}>
        {plans.map(({ plan, monthly_credits: credits, unit_amount: amount }) => {
          const featured = plan === top.plan;
          return <PlanCard key={plan} plan={plan} t={t} name={t(`planShort_${plan}`)} tagline={t(`planTagline_${plan}`)}
            price={formatMoney(amount, currency, locale)} period={t('perMonth')} featured={featured} badge={featured ? t('planRecommended') : null}
            rows={planRows(plan, t, count(credits))}
            action={<Button variant="rounded" color={featured ? 'inverse' : 'overlay'} fullWidth endIcon={<IconArrowRight />} onClick={() => choose(plan)}>
              {t('planSubscribeCta', { plan: t(`planShort_${plan}`) })}
            </Button>} />;
        })}
      </div>
      <div className="studio-landing-plans__aside">
        <Text.caption contrast={6}>{t('landingPlansFree')}</Text.caption>
        <Text.caption contrast={6}>{t('planRenewNote')}</Text.caption>
      </div>
    </div>
  </motion.section>;
}
